import React,{useState,useEffect} from "react"
import { useLocation as location2 } from "wouter";
import Confirm from "../components/Confirm";

const toPesos=function(n){
    const options = { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
    };
    return Number(n).toLocaleString('en', options);  
}
const Cart  = () => {
    const [location, navigate] = location2();
    const [cart, setCart] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const user_id = localStorage.getItem('token');
    if (!user_id) {
        navigate('/login');
    }
    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCart(storedCart);
    }, []);
    const qCartItem = (index, delta) => {
        const updatedCart = [...cart];
        updatedCart[index].q += delta;
        if (updatedCart[index].q <= 0) {
            updatedCart.splice(index, 1);
        }
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
        if(cart.length===0){
            navigate('/');
        }
    }
    return (
        <div id="webcrumbs">
            <Confirm isOpen={confirmOpen} title={'Vaciar carrito'} message={'¿Estás seguro de que deseas vaciar el carrito? Esta acción no se puede deshacer.'}
                onClose={() => setConfirmOpen(false)}
                onConfirm={()=>{
                    setCart([]);
                    localStorage.setItem('cart', JSON.stringify([]));
                    navigate('/');
                }}
                confirmText={'Vaciar carrito'}
            />
            <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white relative pb-16 flex flex-col items-center justify-center text-neutral-700">
                <div className="w-full max-w-3xl px-6 py-10">
                    <div className="flex flex-col items-center mb-8">
                        <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mb-4 shadow-lg transform hover:rotate-12 transition-all">
                            <span className="material-symbols-outlined text-white text-3xl">shopping_cart</span>
                        </div>
                        <h1 className="text-3xl font-bold text-neutral-900 mb-1">Tu Carrito</h1>
                        <p className="text-neutral-600 text-center">
                            Revisa los artículos en tu carrito antes de finalizar tu compra
                        </p>
                    </div>

                    <div className="bg-white rounded-2xl shadow-sm border border-neutral-100 p-6 mb-6 backdrop-blur-sm">
                        <div className="space-y-4">
                            {/* Lista de productos */}
                            <div className="space-y-2 mb-6">
                               {cart.map((item, index) => (
                                   <div key={index} className="flex justify-between p-3 border-b border-neutral-100 hover:bg-neutral-50 transition-all">
                                       <div className="flex-1">
                                           <h3 className="font-medium text-neutral-900">
                                               {item.q} {item.nombre}
                                           </h3>
                                        <p className="text-xs text-neutral-500">
                                            {item.modificadores.map((mod,ix)=>(
                                                <span key={"mod_"+index+"_"+ix} className="block">
                                                    {mod.opts.map((o,i)=>(
                                                        <span key={"opt_"+index+"_"+ix+"_"+i}>
                                                            {o.value} {o.nombre}
                                                        </span>
                                                    ))}
                                                </span>
                                            ))}
                                        </p>
                                    </div>
                                    <div className="flex items-center space-x-4 flex-col ml-5">
                                        <span className="font-medium text-neutral-900 w-20 text-right">${toPesos(item.q*(+item.precio+item.precio_extras))}</span>
                                        <div className="flex mt-5 border border-neutral-200 rounded-lg overflow-hidden">
                                            <button className="px-1.5 py-0.5 bg-neutral-50 hover:bg-neutral-100 transition-colors"
                                                onClick={()=>{qCartItem(index,-1);}}>
                                                {item.q==1?(
                                                    <span className="material-symbols-outlined text-xs">delete</span>
                                                ):(
                                                 <span className="material-symbols-outlined text-xs">remove</span>
                                                )}
                                            </button>
                                            <span className="px-2 py-0.5 flex items-center justify-center">{item.q}</span>
                                            <button className="px-1.5 py-0.5 bg-neutral-50 hover:bg-neutral-100 transition-colors"
                                                onClick={()=>{qCartItem(index,1);}}>
                                                <span className="material-symbols-outlined text-xs">add</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                 ))}

                            </div>

                            {/* Resumen del pedido */}
                            <div className="pt-4">
                                {/*<div className="space-y-2 mb-4">
                                    <div className="flex justify-between text-neutral-600">
                                        <span>Subtotal</span>
                                        <span>$6,596.00</span>
                                    </div>
                                    <div className="flex justify-between text-neutral-600">
                                        <span>Envío</span>
                                        <span>$99.00</span>
                                    </div>
                                    <div className="flex justify-between text-neutral-600">
                                        <span>Impuestos</span>
                                        <span>$1,055.36</span>
                                    </div>
                                </div>*/}

                                <div className="flex justify-between font-semibold text-lg  pt-4">
                                    <span>Total</span>
                                    <span>${cart.reduce((acc, item) => acc + (item.q*(+item.precio + item.precio_extras)), 0).toFixed(2)}</span>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                                <button
                                    type="button"
                                    className="w-full flex items-center justify-center space-x-2 bg-neutral-200 text-neutral-800 py-3.5 rounded-xl font-medium shadow-sm hover:bg-neutral-300 transition-all transform hover:scale-[1.01] active:scale-[0.99]"
                                    onClick={() => setConfirmOpen(true)}
                                >
                                    <span className="material-symbols-outlined">delete_sweep</span>
                                    <span>Vaciar carrito</span>
                                </button>
                                <button
                                    type="button"
                                    className="w-full flex items-center justify-center space-x-2 bg-primary-600 text-white py-3.5 rounded-xl font-medium shadow-sm hover:bg-primary-700 transition-all transform hover:scale-[1.01] active:scale-[0.99]"
                                    onClick={() => navigate('/checkout')}
                                >
                                    <span className="material-symbols-outlined">shopping_bag</span>
                                    <span>Finalizar compra</span>
                                </button>
                            </div>

                            <div className="text-center mt-4">
                                <a
                                    href="#"
                                    className="inline-flex items-center text-primary-600 hover:text-primary-700 transition-colors"
                                    onClick={() => navigate('/order')}
                                >
                                    <span className="material-symbols-outlined text-sm mr-1">arrow_back</span>
                                    Continuar comprando
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Cart;